import React from 'react';
import {
  SEGMENTS,
  SEGMENT_ORDER,
  DEFAULT_COMPOSITION,
  normalizeComposition,
} from '../constants/workoutCompositionSegments';

export default function WorkoutCompositionPicker({
  value,
  onChange,
  className = '',
  title = 'Composição do treino',
}) {
  const selected = normalizeComposition(value);

  const toggle = (id) => {
    if (id === 'treino_principal') return;
    const has = selected.includes(id);
    let next;
    if (has) {
      next = selected.filter((x) => x !== id);
    } else {
      next = [...selected, id];
    }
    onChange?.(normalizeComposition(next), { explicit: true });
  };

  return (
    <div className={`space-y-3 ${className}`}>
      <div>
        <h3 className="section-label mb-1 block">{title}</h3>
        <p className="font-mono text-[10px] text-iron-muted">
          Por padrão a IA monta o treino principal com base nos seus interesses. Marca segmentos
          extra se quiseres aquecimento, alongamento ou desaquecimento explícitos.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {SEGMENT_ORDER.map((id) => {
          const seg = SEGMENTS[id];
          const on = selected.includes(id);
          const locked = seg.required;
          return (
            <button
              key={id}
              type="button"
              title={seg.hint}
              disabled={locked}
              onClick={() => toggle(id)}
              className={`rounded-lg border px-3 py-2 text-left transition-colors ${
                on
                  ? 'border-iron-accent bg-iron-accent/15'
                  : 'border-iron-border text-iron-muted hover:border-iron-accent/60'
              } ${locked ? 'cursor-default opacity-90' : ''}`}
            >
              <div className="font-mono text-xs font-medium text-iron-text">{seg.label}</div>
              <div className="mt-1 font-mono text-[9px] leading-snug text-iron-muted">{seg.hint}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
